// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__268kb","legacyBtn":"MutateMid_legacyBtn__59xOf"};